import { createFileRoute } from "@tanstack/react-router";
import { IdentityAdmin } from "@/components/Identities/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const identityId = params?.id as string;

  return <IdentityAdmin identityId={identityId} />;
}

export const Route = createFileRoute("/_authenticated/identities/$id/")({
  component: RouteComponent,
  staticData: { page: "identities" },
});
